import React from "react";
import Select from "react-select";
import { withRouter } from "react-router-dom";

import moment from "moment";

import { Modal, ProgressBar } from "react-bootstrap";

import { Button } from "aible";

import { LineInput } from "components/Inputs/LineInput";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import DistributionChart from "components/Gallery/Charts/DistributionChart";
import OutcomeChart from "components/Gallery/Charts/OutcomeChart";

import styles from "./style.module.css";

export default class DatasetSearch extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { hDataset: undefined, hField: undefined };
  }

  getHighlightedText(text, highlight) {
    // Split text on highlight term, include term itself into parts, ignore case
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (
      <span className={styles.tHolder}>
        {parts.map((part, i) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span className={styles.tHighlight} key={i}>
              {part}
            </span>
          ) : (
            part
          )
        )}
      </span>
    );
  }

  renderReportsTable() {
    const { search, reports, history } = this.props;
    const { hDataset } = this.state;

    const cStyle = { width: 100 / 5 + "%" };

    const retReports = reports
      ? reports.filter((d) => d.name && d.name.toLowerCase().indexOf(search.toLowerCase()) !== -1)
      : [];

    let retReportFields = [];

    for (const rep of reports) {
      if (rep.charts) {
        for (const chart of rep.charts) {
          if (
            chart &&
            chart.data &&
            chart.data.field &&
            chart.data.field.label &&
            chart.data.field.label.toLowerCase().indexOf(search.toLowerCase()) !== -1
          ) {
            retReportFields.push({
              report: rep,
              field: chart.data.field.label
            });
          }
        }
      }
    }

    const rowLength = retReports.length + retReportFields.length;

    return (
      <div className={styles.dTable}>
        <div className={styles.subHeader} style={{ marginLeft: "20px", marginBottom: "5px" }}>
          {rowLength + " Report(s) found"}
        </div>
        {rowLength > 0 && (
          <div className={styles.gTable}>
            <div className={styles.gTableHeader}>
              <div className={styles.gTableCol} style={cStyle}>
                {"Report Name"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Field"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Owner"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Created"}
              </div>
            </div>
            <div className={styles.gTableBody}>
              {retReports &&
                retReports.map((d, i) => (
                  <div
                    className={
                      styles.gTableRow + " " + (hDataset && hDataset.id === d.id ? styles.gTableRowSelected : "")
                    }
                    key={i}
                  >
                    <div
                      className={styles.gTableCol}
                      style={cStyle}
                      onClick={() => d.report && history.push("report/" + d.report.id)}
                    >
                      <a>{this.getHighlightedText(d.name, search)}</a>
                    </div>
                    <div className={styles.gTableCol} style={cStyle}>
                      {""}
                    </div>
                    <div className={styles.gTableCol} style={cStyle}>
                      {d.created_by ? d.created_by.fullname : ""}
                    </div>
                    <div
                      className={styles.gTableCol}
                      style={cStyle}
                      title={moment.utc(d.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                    >
                      {moment.utc(d.created_date).local().fromNow()}
                    </div>
                  </div>
                ))}
              {retReportFields &&
                retReportFields.map((d, i) => (
                  <div
                    className={
                      styles.gTableRow + " " + (hDataset && hDataset.id === d.id ? styles.gTableRowSelected : "")
                    }
                    key={i}
                  >
                    <div
                      className={styles.gTableCol}
                      style={cStyle}
                      onClick={() => d.report && history.push("report/" + d.report.id)}
                    >
                      <a>{this.getHighlightedText(d.report.name, search)}</a>
                    </div>
                    <div className={styles.gTableCol} style={cStyle}>
                      {this.getHighlightedText(d.field, search)}
                    </div>
                    <div className={styles.gTableCol} style={cStyle}>
                      {d.report.created_by ? d.report.created_by.fullname : ""}
                    </div>
                    <div
                      className={styles.gTableCol}
                      style={cStyle}
                      title={moment.utc(d.report.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                    >
                      {moment.utc(d.report.created_date).local().fromNow()}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderDatasetTable() {
    const { search, datasets, history } = this.props;
    const { hDataset } = this.state;

    const cStyle = { width: 100 / 5 + "%" };

    const retDatasets = datasets
      ? datasets.filter((d) => d.name && d.name.toLowerCase().indexOf(search.toLowerCase()) !== -1)
      : [];

    return (
      <div className={styles.dTable}>
        <div className={styles.subHeader} style={{ marginLeft: "20px", marginBottom: "5px" }}>
          {retDatasets && retDatasets.length + " Dataset(s) found"}
        </div>
        {retDatasets && retDatasets.length > 0 && (
          <div className={styles.gTable}>
            <div className={styles.gTableHeader}>
              <div className={styles.gTableCol} style={cStyle}>
                {"Dataset Name"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Columns"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Rows"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Owner"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Created"}
              </div>
            </div>
            <div className={styles.gTableBody}>
              {retDatasets &&
                retDatasets.map((d, i) => (
                  <div
                    className={
                      styles.gTableRow + " " + (hDataset && hDataset.id === d.id ? styles.gTableRowSelected : "")
                    }
                    key={i}
                  >
                    <div className={styles.gTableCol} style={cStyle} onClick={() => history.push("gallery/" + d.id)}>
                      <a>{this.getHighlightedText(d.name, search)}</a>
                    </div>
                    <div className={styles.gTableCol} style={cStyle}>
                      {d.fields ? Object.keys(d.fields).length : ""}
                    </div>
                    <div className={styles.gTableCol} style={cStyle}>
                      {d.rowCount}
                    </div>
                    <div className={styles.gTableCol} style={cStyle}>
                      {d.created_by ? d.created_by.fullname : ""}
                    </div>
                    <div
                      className={styles.gTableCol}
                      style={cStyle}
                      title={moment.utc(d.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                    >
                      {moment.utc(d.created_date).local().fromNow()}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderCharts() {
    const { search, datasets, updateViewField, history } = this.props;

    const retFields = datasets
      ? datasets
          .filter(
            (d) =>
              d.fields &&
              Object.keys(d.fields).filter((f) => f.toLowerCase().indexOf(search.toLowerCase()) !== -1).length > 0
          )
          .map((d) => ({
            dataset: d,
            fields: Object.keys(d.fields).filter((f) => f.toLowerCase().indexOf(search.toLowerCase()) !== -1)
          }))
      : [];

    const fieldCount = retFields ? retFields.reduce((a, b) => a + b.fields.length, 0) : 0;

    return (
      <div className={styles.dataCharts} style={{ marginBottom: "20px" }}>
        <div className={styles.dataChartsHeader} style={{ padding: "10px", paddingLeft: "0px" }}>
          {fieldCount * 2 + " charts found"}
        </div>
        <div
          className={styles.dataChartsContent}
          onMouseLeave={() => this.setState({ hDataset: undefined, hField: undefined })}
        >
          {retFields.map((r) => {
            return r.fields.map((f, i) => (
              <div
                key={i}
                className={styles.dataFlex}
                onMouseEnter={() => this.setState({ hDataset: r.dataset, hField: f })}
              >
                <div
                  className={styles.dataChart}
                  onClick={() => {
                    updateViewField(r.dataset.id, r.dataset.fields[f]);
                    return history.push("gallery/" + r.dataset.id);
                  }}
                >
                  <OutcomeChart
                    height={125}
                    width={300}
                    isSmall
                    showTitle
                    field={r.dataset.fields[f]}
                    dataset={r.dataset}
                  />
                </div>
                <div
                  className={styles.dataChart}
                  onClick={() => {
                    updateViewField(r.dataset.id, r.dataset.fields[f]);
                    return history.push("gallery/" + r.dataset.id);
                  }}
                >
                  <DistributionChart
                    height={125}
                    width={300}
                    isMini
                    showTitle
                    field={r.dataset.fields[f]}
                    dataset={r.dataset}
                  />
                </div>
              </div>
            ));
          })}
        </div>
      </div>
    );
  }

  renderFieldsTable() {
    const { search, datasets, history } = this.props;
    const { hDataset, hField } = this.state;

    const cStyle = { width: 100 / 6 + "%" };

    const retFields = datasets
      ? datasets
          .filter((d) => d.labels && d.labels.filter((f) => f.toLowerCase().indexOf(search.toLowerCase()) !== -1))
          .map((d) => ({
            dataset: d,
            fields: d.labels.filter((f) => f.toLowerCase().indexOf(search.toLowerCase()) !== -1)
          }))
      : [];

    const fieldCount = retFields ? retFields.reduce((a, b) => a + b.fields.length, 0) : 0;

    return (
      <div className={styles.dTable}>
        <div className={styles.subHeader} style={{ marginLeft: "20px", marginBottom: "5px" }}>
          {fieldCount + " Field(s) found"}
        </div>
        {fieldCount > 0 && (
          <div className={styles.gTable}>
            <div className={styles.gTableHeader}>
              <div className={styles.gTableCol} style={cStyle}>
                {"Dataset Name"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Columns"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Rows"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Field"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Owner"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Created"}
              </div>
            </div>
            <div className={styles.gTableBody}>
              {retFields &&
                retFields.map((d) =>
                  d.fields.map((f, i) => (
                    <div
                      className={
                        styles.gTableRow +
                        " " +
                        (hDataset && hDataset.id === d.dataset.id && hField && hField === f
                          ? styles.gTableRowSelected
                          : "")
                      }
                      key={i}
                    >
                      <div
                        className={styles.gTableCol}
                        style={cStyle}
                        onClick={() => history.push("gallery/" + d.dataset.id)}
                      >
                        <a>{d.dataset.name}</a>
                      </div>
                      <div className={styles.gTableCol} style={cStyle}>
                        {d.dataset.fields ? Object.keys(d.dataset.fields).length : ""}
                      </div>
                      <div className={styles.gTableCol} style={cStyle}>
                        {d.dataset.rowCount}
                      </div>
                      <div className={styles.gTableCol} style={cStyle}>
                        {this.getHighlightedText(f, search)}
                      </div>
                      <div className={styles.gTableCol} style={cStyle}>
                        {d.dataset.created_by ? d.dataset.created_by.fullname : ""}
                      </div>
                      <div
                        className={styles.gTableCol}
                        style={cStyle}
                        title={moment.utc(d.dataset.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                      >
                        {moment.utc(d.dataset.created_date).local().fromNow()}
                      </div>
                    </div>
                  ))
                )}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderValuesTable() {
    const { search, datasets, history } = this.props;

    const cStyle = { width: 100 / 7 + "%" };

    const retValues = datasets
      ? datasets
          .filter(
            (d) =>
              d.fields &&
              Object.keys(d.fields).filter(
                (f) =>
                  d.fields[f].data &&
                  d.fields[f].data.filter((v) => (v.value + "").toLowerCase().indexOf(search.toLowerCase()) !== -1)
              )
          )
          .map((d) => ({
            dataset: d,
            fields: Object.keys(d.fields)
              .filter(
                (f) =>
                  d.fields[f].data &&
                  d.fields[f].data.filter((v) => (v.value + "").toLowerCase().indexOf(search.toLowerCase()) !== -1)
                    .length > 0
              )
              .map((f) => ({
                field: d.fields[f],
                values: d.fields[f].data.filter(
                  (v) => (v.value + "").toLowerCase().indexOf(search.toLowerCase()) !== -1
                )
              }))
          }))
      : [];

    const valueCount = retValues
      ? retValues.reduce((a, b) => a + b.fields.reduce((c, d) => c + d.values.length, 0), 0)
      : 0;

    return (
      <div className={styles.dTable}>
        <div className={styles.subHeader} style={{ marginLeft: "20px", marginBottom: "5px" }}>
          {valueCount + " Values(s) found"}
        </div>
        {valueCount > 0 && (
          <div className={styles.gTable}>
            <div className={styles.gTableHeader}>
              <div className={styles.gTableCol} style={cStyle}>
                {"Dataset Name"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Columns"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Rows"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Field"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Value"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Owner"}
              </div>
              <div className={styles.gTableCol} style={cStyle}>
                {"Created"}
              </div>
            </div>
            <div className={styles.gTableBody}>
              {retValues &&
                retValues.map((d) =>
                  d.fields.map((f) =>
                    f.values.map((v, i) => (
                      <div className={styles.gTableRow} key={i}>
                        <div
                          className={styles.gTableCol}
                          style={cStyle}
                          onClick={() => history.push("gallery/" + d.dataset.id)}
                        >
                          <a>{d.dataset.name}</a>
                        </div>
                        <div className={styles.gTableCol} style={cStyle}>
                          {d.dataset.fields ? Object.keys(d.dataset.fields).length : ""}
                        </div>
                        <div className={styles.gTableCol} style={cStyle}>
                          {d.dataset.rowCount}
                        </div>
                        <div className={styles.gTableCol} style={cStyle}>
                          {f.field.label}
                        </div>
                        <div
                          className={styles.gTableCol}
                          style={{
                            ...cStyle
                          }}
                        >
                          {this.getHighlightedText(v.value, search)}
                        </div>
                        <div className={styles.gTableCol} style={cStyle}>
                          {d.dataset.created_by ? d.dataset.created_by.fullname : ""}
                        </div>
                        <div
                          className={styles.gTableCol}
                          style={cStyle}
                          title={moment.utc(d.dataset.created).local().format("MMMM Do YYYY, h:mm:ss a")}
                        >
                          {moment.utc(d.dataset.created).local().fromNow()}
                        </div>
                      </div>
                    ))
                  )
                )}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderIsSearching() {
    return (
      <div className={styles.datasetSearch}>
        <div className={styles.mediumBold} style={{ marginLeft: "20px", marginBottom: "20px" }}>
          {"Searching Datasets... Please wait"}
        </div>
        <LoadingIndicator />
      </div>
    );
  }

  render() {
    const { search, isDatasetSearching } = this.props;

    return isDatasetSearching ? (
      this.renderIsSearching()
    ) : (
      <div className={styles.datasetSearch}>
        <div className={styles.mediumBold} style={{ marginLeft: "20px", marginBottom: "20px" }}>
          {'Search Results for "' + search + '"'}
        </div>
        {/* this.renderCharts() */}
        {this.renderReportsTable()}
        {this.renderDatasetTable()}
        {this.renderFieldsTable()}
        {/* this.renderValuesTable() */}
      </div>
    );
  }
}
